import {
  faApple,
  faDiscord,
  faFacebook,
  faGithub,
  faGoogle,
  faMicrosoft,
  faSquareJs,
} from '@fortawesome/free-brands-svg-icons';
import {
  faAngleRight,
  faBan,
  faBomb,
  faBook,
  faBookOpen,
  faBox,
  faBolt,
  faBoxesStacked,
  faBrain,
  faCalendarCheck,
  faChartSimple,
  faCircleExclamation,
  faClockRotateLeft,
  faCode,
  faCodeBranch,
  faCompress,
  faDeleteLeft,
  faDiagramProject,
  faDolly,
  faDoorClosed,
  faDoorOpen,
  faDownload,
  faEdit,
  faEnvelope,
  faEnvelopeCircleCheck,
  faEye,
  faEyeSlash,
  faFile,
  faFileCircleCheck,
  faFileCode,
  faFileExport,
  faFileImport,
  faFilePen,
  faFilter,
  faFlaskVial,
  faHourglassHalf,
  faFolder,
  faFolderPlus,
  faGaugeHigh,
  faGear,
  faGlobe,
  faHandSparkles,
  faHashtag,
  faIdCard,
  faKey,
  faLink,
  faLock,
  faLinkSlash,
  faListUl,
  faLockOpen,
  faMagicWandSparkles,
  faMagnifyingGlass,
  faMemory,
  faMobileScreenButton,
  faPassport,
  faListCheck,
  faPlug,
  faRobot,
  faPlus,
  faPuzzlePiece,
  faQuoteLeft,
  faRefresh,
  faRightLeft,
  faRightToBracket,
  faRocket,
  faRulerHorizontal,
  faServer,
  faShieldHalved,
  faShuffle,
  faSignature,
  faSitemap,
  faSortAlphaAsc,
  faSquarePlus,
  faSquareRootVariable,
  faPaperPlane,
  faStopwatch,
  faTags,
  faTerminal,
  faTimeline,
  faToolbox,
  faTrash,
  faTriangleExclamation,
  faUserGroup,
  faUserLock,
} from '@fortawesome/free-solid-svg-icons';
import config from '../config';
import { DocumentationContents } from '../types';

export const documentationContents: DocumentationContents = [
  {
    title: 'Home',
    icon: faBookOpen,
    url: '',
    contents: [
      {
        title: 'Getting started',
        icon: faRocket,
        url: '/getting-started',
        contents: [
          {
            title: 'Create a list',
            icon: faFolderPlus,
            url: '/getting-started#step-1-create-a-list',
          },
          {
            title: 'Add some items',
            icon: faSquarePlus,
            url: '/getting-started#step-2-add-some-items',
          },
          {
            title: 'Fetch all items',
            icon: faBoxesStacked,
            url: '/getting-started#step-3-fetch-all-items',
          },
          {
            title: 'Fetch an item',
            icon: faBox,
            url: '/getting-started#step-4-fetch-an-item',
          },
          {
            title: 'Update an item',
            icon: faDolly,
            url: '/getting-started#step-5-update-an-item',
          },
        ],
      },
      {
        title: 'Talking to the API',
        icon: faPlug,
        url: '/talking-to-the-api',
        contents: [
          {
            title: 'cURL',
            icon: faTerminal,
            url: '/talking-to-the-api#curl',
          },
          {
            title: 'JS/TS',
            icon: faSquareJs,
            url: '/talking-to-the-api#node-fetch-and-axios',
          },
          {
            title: 'HTTP methods',
            icon: faGlobe,
            url: '/talking-to-the-api#http-methods',
          },
          {
            title: 'Rate limits',
            icon: faGaugeHigh,
            url: '/talking-to-the-api#rate-limits',
          },
          {
            title: 'Caching',
            icon: faMemory,
            url: '/talking-to-the-api#caching',
          },
        ],
      },
      {
        title: 'List schemas',
        icon: faFileCircleCheck,
        url: '/list-schemas',
      },
      {
        title: 'Indexing lists',
        icon: faTags,
        url: '/indexing',
        contents: [
          {
            title: 'Creating an index',
            icon: faPlus,
            url: '/indexing#creating-an-index',
          },
          {
            title: 'Index builds',
            icon: faHourglassHalf,
            url: '/indexing#index-builds',
          },
          {
            title: 'Alias indexes',
            icon: faSignature,
            url: '/indexing#alias-indexes',
          },
          {
            title: 'Long values',
            icon: faRulerHorizontal,
            url: '/indexing#long-values',
          },
          {
            title: 'Sorting lists',
            icon: faSortAlphaAsc,
            url: '/indexing#sorting-lists',
          },
          {
            title: 'Filtering items',
            icon: faFilter,
            url: '/indexing#filtering-items',
          },
          {
            title: 'Searching lists',
            icon: faMagnifyingGlass,
            url: '/indexing#searching-lists',
          },
          {
            title: 'Guard indexes',
            icon: faEyeSlash,
            url: '/indexing#guard-indexes',
          },
        ],
      },
      {
        title: 'Paths and pointers',
        icon: faAngleRight,
        url: '/paths-and-pointers',
        contents: [
          {
            title: 'Fetch partial data',
            icon: faPuzzlePiece,
            url: '/paths-and-pointers#fetch-partial-data',
          },
          {
            title: 'Update partial data',
            icon: faEdit,
            url: '/paths-and-pointers#update-partial-data',
          },
          {
            title: 'Delete partial data',
            icon: faDeleteLeft,
            url: '/paths-and-pointers#delete-partial-data',
          },
        ],
      },
      {
        title: 'Token permissions',
        icon: faLockOpen,
        url: '/token-permissions',
      },
      {
        title: 'Tags',
        icon: faHashtag,
        url: '/tags',
        contents: [
          {
            title: 'Adding tags',
            icon: faPlus,
            url: '/tags#adding-tags',
          },
          {
            title: 'Filtering by tag',
            icon: faFilter,
            url: '/tags#filtering-by-tag',
          },
          {
            title: 'Tags in the dashboard',
            icon: faMagnifyingGlass,
            url: '/tags#tags-in-the-dashboard',
          },
        ],
      },
      {
        title: 'Schema sync',
        icon: faSitemap,
        url: '/schema-sync',
        contents: [
          {
            title: 'The document',
            icon: faFileCode,
            url: '/schema-sync#the-document',
          },
          {
            title: 'Syncing',
            icon: faRefresh,
            url: '/schema-sync#syncing',
          },
          {
            title: 'Scopes',
            icon: faHashtag,
            url: '/schema-sync#scopes',
          },
          {
            title: 'Exporting existing lists',
            icon: faFileExport,
            url: '/schema-sync#exporting',
          },
          {
            title: 'The command line tool',
            icon: faTerminal,
            url: '/schema-sync#the-command-line-tool',
          },
        ],
      },
      {
        title: 'Write rules',
        icon: faShieldHalved,
        url: '/write-rules',
        contents: [
          {
            title: 'Authorise, then validate',
            icon: faUserLock,
            url: '/write-rules#authorise-then-validate',
          },
          {
            title: 'The order of a write',
            icon: faListUl,
            url: '/write-rules#the-order-of-a-write',
          },
          {
            title: 'What a rule can see',
            icon: faEye,
            url: '/write-rules#what-a-rule-can-see',
          },
          {
            title: 'Shared items',
            icon: faUserGroup,
            url: '/write-rules#shared-items',
          },
          {
            title: 'Consistency',
            icon: faLock,
            url: '/write-rules#consistency',
          },
          {
            title: 'Writing and testing rules',
            icon: faFlaskVial,
            url: '/write-rules#writing-and-testing',
          },
          {
            title: 'Refused writes',
            icon: faBan,
            url: '/write-rules#refused-writes',
          },
          {
            title: 'Language reference',
            icon: faBook,
            url: '/write-rules-reference',
          },
          {
            title: 'Recipes',
            icon: faQuoteLeft,
            url: '/write-rules-recipes',
          },
        ],
      },
      {
        title: 'Command line tool',
        icon: faTerminal,
        url: '/command-line-tool',
        contents: [
          {
            title: 'Installing',
            icon: faDownload,
            url: '/command-line-tool#installing',
          },
          {
            title: 'Authentication and profiles',
            icon: faKey,
            url: '/command-line-tool#authentication-and-profiles',
          },
          {
            title: 'Output formats',
            icon: faListUl,
            url: '/command-line-tool#output-formats',
          },
          {
            title: 'Exporting and importing items',
            icon: faFileImport,
            url: '/command-line-tool#exporting-and-importing-items',
          },
          {
            title: 'Using it in CI',
            icon: faCodeBranch,
            url: '/command-line-tool#continuous-integration',
          },
          {
            title: 'Command reference',
            icon: faBook,
            url: '/command-line-tool#command-reference',
          },
        ],
      },
      {
        title: 'Authentication',
        icon: faPassport,
        url: '/authentication',
      },
      {
        title: 'Identity groups',
        icon: faUserGroup,
        url: '/identity-groups',
      },
      {
        title: 'Password reset',
        icon: faUserLock,
        url: '/identity-password-reset',
        contents: [
          {
            title: 'Token delivery',
            icon: faKey,
            url: '/identity-password-reset#token-delivery',
          },
          {
            title: 'Receiving webhooks',
            icon: faServer,
            url: '/identity-password-reset#receiving-webhooks',
          },
          {
            title: 'Email verification',
            icon: faEnvelopeCircleCheck,
            url: '/identity-password-reset#email-verification',
          },
        ],
      },
      {
        title: 'Signing in with a provider',
        icon: faRightToBracket,
        url: '/identity-oauth',
        contents: [
          {
            title: 'In your app',
            icon: faCode,
            url: '/identity-oauth#in-your-app',
          },
          {
            title: 'Callback modes',
            icon: faShuffle,
            url: '/identity-oauth#callback-modes',
          },
          {
            title: 'Linking accounts',
            icon: faLink,
            url: '/identity-oauth#linking-accounts',
          },
          {
            title: 'Sign in with Google',
            icon: faGoogle,
            url: '/identity-oauth-google',
          },
          {
            title: 'Sign in with GitHub',
            icon: faGithub,
            url: '/identity-oauth-github',
          },
          {
            title: 'Sign in with Apple',
            icon: faApple,
            url: '/identity-oauth-apple',
          },
          {
            title: 'Sign in with Microsoft',
            icon: faMicrosoft,
            url: '/identity-oauth-microsoft',
          },
          {
            title: 'Sign in with Discord',
            icon: faDiscord,
            url: '/identity-oauth-discord',
          },
          {
            title: 'Sign in with Facebook',
            icon: faFacebook,
            url: '/identity-oauth-facebook',
          },
        ],
      },
      {
        title: 'Realtime updates',
        icon: faStopwatch,
        url: '/realtime-updates',
      },
      {
        title: 'Webhooks',
        icon: faPaperPlane,
        url: '/webhooks',
        contents: [
          {
            title: 'Creating a webhook',
            icon: faSquarePlus,
            url: '/webhooks#creating-a-webhook',
          },
          {
            title: 'Events',
            icon: faPlug,
            url: '/webhooks#events',
          },
          {
            title: 'The payload',
            icon: faPuzzlePiece,
            url: '/webhooks#payload',
          },
          {
            title: 'Verifying signatures',
            icon: faSignature,
            url: '/webhooks#verifying-signatures',
          },
          {
            title: 'Retries',
            icon: faShuffle,
            url: '/webhooks#retries',
          },
        ],
      },
      {
        title: 'Flows',
        icon: faDiagramProject,
        url: '/flows',
        contents: [
          {
            title: 'A first flow',
            icon: faRocket,
            url: '/flows#a-first-flow',
          },
          {
            title: 'How a flow runs',
            icon: faListUl,
            url: '/flows#how-a-flow-runs',
          },
          {
            title: 'What a flow can do',
            icon: faShieldHalved,
            url: '/flows#privileges',
          },
          {
            title: 'Calling an endpoint flow',
            icon: faPlug,
            url: '/flows#calling-an-endpoint-flow',
          },
          {
            title: 'Testing flows',
            icon: faFlaskVial,
            url: '/flows#testing-flows',
          },
          {
            title: 'Keeping flows in git',
            icon: faCodeBranch,
            url: '/flows#keeping-flows-in-git',
          },
          {
            title: 'Limits and cost',
            icon: faGaugeHigh,
            url: '/flows#limits-and-cost',
          },
          {
            title: 'Event flows',
            icon: faBolt,
            url: '/flows-events',
          },
          {
            title: 'Reference',
            icon: faBook,
            url: '/flows-reference',
          },
        ],
      },
      {
        title: 'Event log',
        icon: faTimeline,
        url: '/event-log',
      },
      {
        title: 'Version control',
        icon: faClockRotateLeft,
        url: '/version-control',
      },
      {
        title: 'Using the SDKs',
        icon: faToolbox,
        url: '/using-the-sdks',
        contents: [
          {
            title: 'Server',
            icon: faServer,
            url: '/using-the-sdks#server-example',
          },
          {
            title: 'Browser',
            icon: faMobileScreenButton,
            url: '/using-the-sdks#browser-example',
          },
        ],
      },
      {
        title: 'MCP servers',
        icon: faRobot,
        url: '/mcp',
        contents: [
          {
            title: 'Adding the docs server',
            icon: faPlug,
            url: '/mcp#adding-the-docs-server',
          },
          {
            title: 'Checking rules and flows',
            icon: faListCheck,
            url: '/mcp#checking-rules-and-flows',
          },
          {
            title: 'Adding the API server',
            icon: faKey,
            url: '/mcp#adding-the-api-server',
          },
          {
            title: 'API server safeguards',
            icon: faLock,
            url: '/mcp#api-server-safeguards',
          },
        ],
      },
      ...(config.generativeAPIEnabled
        ? [
            {
              title: 'Generative API',
              icon: faBrain,
              url: '/generative-api',
              contents: [
                {
                  title: 'Fetch and generate',
                  icon: faHandSparkles,
                  url: '/generative-api#fetch-and-generate',
                },
                {
                  title: 'Create and generate',
                  icon: faMagicWandSparkles,
                  url: '/generative-api#create-and-generate',
                },
              ],
            },
          ]
        : []),
      {
        title: 'Variables',
        icon: faSquareRootVariable,
        url: '/variables',
      },
      {
        title: 'JSON5',
        icon: faQuoteLeft,
        url: '/json5',
      },
      {
        title: 'MessagePack',
        icon: faCompress,
        url: '/msgpack',
      },
    ],
  },
  {
    title: 'API reference',
    icon: faGear,
    url: '/api-reference',
    contents: [
      {
        title: 'Lists',
        icon: faFolder,
        url: '/lists',
        contents: [
          {
            title: 'Create a list',
            icon: faPlus,
            url: '/list-create',
          },
          {
            title: 'Fetch all lists',
            icon: faListUl,
            url: '/lists-index',
          },
          {
            title: 'View a list',
            icon: faFile,
            url: '/list-view',
          },
          {
            title: 'Search a list',
            icon: faMagnifyingGlass,
            url: '/list-search',
          },
          {
            title: 'Fetch list stats',
            icon: faChartSimple,
            url: '/list-stats',
          },
          {
            title: 'Fetch list events',
            icon: faClockRotateLeft,
            url: '/list-events',
          },
          {
            title: 'View a list event',
            icon: faCalendarCheck,
            url: '/list-event',
          },
          {
            title: 'Update a list',
            icon: faFilePen,
            url: '/list-update',
          },
          {
            title: "Test a list's write rules",
            icon: faShieldHalved,
            url: '/list-rules-test',
          },
          {
            title: 'Fetch refused writes',
            icon: faBan,
            url: '/list-rule-denials',
          },
          {
            title: 'Delete a list',
            icon: faTrash,
            url: '/list-delete',
          },
        ],
      },
      {
        title: 'Items',
        icon: faFileCode,
        url: '/items',
        contents: [
          {
            title: 'Create an item',
            icon: faPlus,
            url: '/item-create',
          },
          {
            title: 'Fetch all items',
            icon: faListUl,
            url: '/items-index',
          },
          {
            title: 'Fetch all item data',
            icon: faListUl,
            url: '/items-index-data',
          },
          {
            title: 'Fetch partial item data',
            icon: faListUl,
            url: '/items-index-partial-data',
          },
          {
            title: 'View an item',
            icon: faFile,
            url: '/item-view',
          },
          {
            title: 'View item data',
            icon: faFile,
            url: '/item-view-data',
          },
          {
            title: 'View partial item data',
            icon: faFile,
            url: '/item-view-partial-data',
          },
          {
            title: 'Fetch item stats',
            icon: faChartSimple,
            url: '/item-stats',
          },
          {
            title: 'Fetch item events',
            icon: faClockRotateLeft,
            url: '/item-events',
          },
          {
            title: 'View an item event',
            icon: faCalendarCheck,
            url: '/item-event',
          },
          {
            title: 'Restore an item',
            icon: faClockRotateLeft,
            url: '/item-restore',
          },
          {
            title: 'Update an item',
            icon: faFilePen,
            url: '/item-update',
          },
          {
            title: 'Update item data',
            icon: faFilePen,
            url: '/item-update-data',
          },
          {
            title: 'Replace item data',
            icon: faFilePen,
            url: '/item-replace-data',
          },
          {
            title: 'Patch item data',
            icon: faFilePen,
            url: '/item-patch-data',
          },
          {
            title: 'Update partial item data',
            icon: faFilePen,
            url: '/item-update-partial-data',
          },
          {
            title: 'Replace partial item data',
            icon: faFilePen,
            url: '/item-replace-partial-data',
          },
          {
            title: 'Patch partial item data',
            icon: faFilePen,
            url: '/item-patch-partial-data',
          },
          {
            title: 'Delete an item',
            icon: faTrash,
            url: '/item-delete',
          },
          {
            title: 'Delete partial item data',
            icon: faTrash,
            url: '/item-delete-partial-data',
          },
        ],
      },
      {
        title: 'Indexes',
        icon: faTags,
        url: '/indexes',
        contents: [
          {
            title: 'Create an index',
            icon: faPlus,
            url: '/index-create',
          },
          {
            title: 'Fetch all indexes',
            icon: faListUl,
            url: '/indexes-index',
          },
          {
            title: 'View an index',
            icon: faFile,
            url: '/index-view',
          },
          {
            title: 'Fetch index stats',
            icon: faChartSimple,
            url: '/index-stats',
          },
          {
            title: 'Fetch index events',
            icon: faClockRotateLeft,
            url: '/index-events',
          },
          {
            title: 'View an index event',
            icon: faCalendarCheck,
            url: '/index-event',
          },
          {
            title: 'Update an index',
            icon: faFilePen,
            url: '/index-update',
          },
          {
            title: 'Rebuild an index',
            icon: faRefresh,
            url: '/index-rebuild',
          },
          {
            title: 'Delete an index',
            icon: faTrash,
            url: '/index-delete',
          },
        ],
      },
      {
        title: 'Identities',
        icon: faIdCard,
        url: '/identities',
        contents: [
          {
            title: 'Create an identity',
            icon: faPlus,
            url: '/identity-create',
          },
          {
            title: 'Fetch all identities',
            icon: faListUl,
            url: '/identities-index',
          },
          {
            title: 'View an identity',
            icon: faFile,
            url: '/identity-view',
          },
          {
            title: 'Fetch identity stats',
            icon: faChartSimple,
            url: '/identity-stats',
          },
          {
            title: 'Fetch identity events',
            icon: faClockRotateLeft,
            url: '/identity-events',
          },
          {
            title: 'View an identity event',
            icon: faCalendarCheck,
            url: '/identity-event',
          },
          {
            title: 'Update an identity',
            icon: faFilePen,
            url: '/identity-update',
          },
          {
            title: 'Delete an identity',
            icon: faTrash,
            url: '/identity-delete',
          },
          {
            title: 'Register an identity',
            icon: faPassport,
            url: '/identity-register',
          },
          {
            title: 'Login an identity',
            icon: faDoorOpen,
            url: '/identity-login',
          },
          {
            title: 'Logout an identity',
            icon: faDoorClosed,
            url: '/identity-logout',
          },
          {
            title: 'Fetch the current identity',
            icon: faFile,
            url: '/identity-view-self',
          },
          {
            title: 'Update the current identity',
            icon: faFilePen,
            url: '/identity-update-self',
          },
          {
            title: 'Delete the current identity',
            icon: faTrash,
            url: '/identity-delete-self',
          },
          {
            title: 'List sign-in providers',
            icon: faRightToBracket,
            url: '/identity-oauth-providers',
          },
          {
            title: 'Start signing in with a provider',
            icon: faRightToBracket,
            url: '/identity-oauth-start',
          },
          {
            title: 'Finish signing in with a provider',
            icon: faRightToBracket,
            url: '/identity-oauth-complete',
          },
          {
            title: "List the current identity's linked accounts",
            icon: faLink,
            url: '/identity-self-providers',
          },
          {
            title: 'Link a provider account',
            icon: faLink,
            url: '/identity-self-provider-link',
          },
          {
            title: 'Unlink a provider account',
            icon: faLinkSlash,
            url: '/identity-self-provider-unlink',
          },
          {
            title: 'Request a password reset token',
            icon: faKey,
            url: '/identity-password-reset-request',
          },
          {
            title: 'Reset a password',
            icon: faUserLock,
            url: '/identity-password-reset-confirm',
          },
          {
            title: 'Request an email verification token',
            icon: faEnvelope,
            url: '/identity-email-verification-request',
          },
          {
            title: 'Verify an email address',
            icon: faEnvelopeCircleCheck,
            url: '/identity-email-verification-confirm',
          },
        ],
      },
      {
        title: 'Fetch the current token',
        icon: faKey,
        url: '/token-view-self',
      },
      {
        title: 'Run a flow',
        icon: faDiagramProject,
        url: '/flow-run',
      },
      {
        title: 'Schema sync',
        icon: faSitemap,
        url: '/schema-sync',
        contents: [
          {
            title: 'Sync a schema',
            icon: faRefresh,
            url: '/sync-schema',
          },
          {
            title: 'Export a schema',
            icon: faFileExport,
            url: '/sync-schema-export',
          },
          {
            title: 'Move lists between scopes',
            icon: faRightLeft,
            url: '/sync-schema-move',
          },
        ],
      },
      {
        title: 'Limits and quotas',
        icon: faGaugeHigh,
        url: '/limits-and-quotas',
        contents: [
          {
            title: 'What counts as a request',
            icon: faStopwatch,
            url: '/limits-and-quotas#what-counts',
          },
          {
            title: 'Response headers',
            icon: faTags,
            url: '/limits-and-quotas#response-headers',
          },
          {
            title: 'What happens when you run out',
            icon: faTriangleExclamation,
            url: '/limits-and-quotas#running-out',
          },
          {
            title: 'When the allowance resets',
            icon: faCalendarCheck,
            url: '/limits-and-quotas#reset',
          },
          {
            title: 'Storage',
            icon: faMemory,
            url: '/limits-and-quotas#storage',
          },
          {
            title: 'Rate limits',
            icon: faStopwatch,
            url: '/limits-and-quotas#rate-limits',
          },
          {
            title: 'Version history',
            icon: faClockRotateLeft,
            url: '/limits-and-quotas#version-history',
          },
          {
            title: 'What is not limited',
            icon: faLockOpen,
            url: '/limits-and-quotas#uncapped',
          },
        ],
      },
      {
        title: 'Errors',
        icon: faCircleExclamation,
        url: '/errors',
        contents: [
          {
            title: 'Error object',
            icon: faBomb,
            url: '/errors#error-object',
          },
          {
            title: 'Error codes',
            icon: faTriangleExclamation,
            url: '/errors#error-codes',
          },
        ],
      },
    ],
  },
];
